const FEATURE_FLAG_STORAGE_KEY = 'feature_flags';
export const FEATURE_FLAGS = [
    'mock_enabled',
    'fb_custom_audience_targeting',
    // Until we support campaign-level payment requests, we will allow certain users to still use the old flow.
    // An example case is clipping campaigns, where one post payment actually represents multiple posts.
    'legacy_post_payments',
    'mobile_advertising',
    'microwave_tiktok_campaigns_management',
    'email_preview_detailed_results',
    'creatorbase_detailed_credit_limits',
    '2151_billing_entity_settings',
    'rou_211_payment_credit_limit_banner',
    'rou_539_campaign_payment_requests',
    'bulk_post_upload_async',
    'rou_1532_creator_cost_mismatch_banner',
    'rou_1766_project_genres',
    'project_sharing',
] as const;

export type FeatureFlagName = (typeof FEATURE_FLAGS)[number];
export type FeatureFlags = Record<FeatureFlagName, boolean>;

export const getFlags = (): FeatureFlags => {
    const val = localStorage.getItem(FEATURE_FLAG_STORAGE_KEY);
    return JSON.parse(val ?? '{}');
};

export const saveFlags = (flags: Partial<FeatureFlags>) => {
    localStorage.setItem(FEATURE_FLAG_STORAGE_KEY, JSON.stringify(flags));
};
